module.exports = __webpack_public_path__ + "static/media/back-gray.cc08d0a4.png";